import { useGetBase64Image } from './UseGetBase64Image';

const useGetBackground = (
  solidColor: string,
  value: string,
  scale?: number,
  scaleBool?: boolean,
) => {
  let result = {};
  if (solidColor) {
    result = { backgroundColor: solidColor };
  }

  const base64Image = useGetBase64Image(value);
  if (value) {
    if (!scale) scale = 1;

    let backgroundSize = `${scale * 100}%`;
    if (!scaleBool) {
      backgroundSize = 'cover';
    } else {
      backgroundSize = `${scale * 100}%`;
    }
    result = {
      backgroundImage: `url(${base64Image})`,
      backgroundSize,
    };
  }
  return result;
};

export default useGetBackground;
